const SvgMemory = props => (
  <svg height="1em" viewBox="0 0 24 16" width="1em" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M18.403 15.815h-2.378V12.86a.713.713 0 0 0-1.426 0v2.955H9.372V12.86a.713.713 0 1 0-1.427 0v2.955H5.567V12.86a.713.713 0 1 0-1.427 0v2.955H.65a.3.3 0 0 1-.3-.3V.708a.3.3 0 0 1 .3-.3H23.7a.3.3 0 0 1 .3.3v14.807a.3.3 0 0 1-.3.3h-3.87V12.86a.713.713 0 1 0-1.427 0v2.955zm-15-13.573a.4.4 0 0 0-.4.4V9.18c0 .22.18.4.4.4h3.748a.4.4 0 0 0 .4-.4V2.642a.4.4 0 0 0-.4-.4H3.404zm6.822 0a.4.4 0 0 0-.4.4V9.18c0 .22.179.4.4.4h3.747a.4.4 0 0 0 .4-.4V2.642a.4.4 0 0 0-.4-.4h-3.747zm6.82 0a.4.4 0 0 0-.4.4V9.18c0 .22.18.4.4.4h3.748a.4.4 0 0 0 .4-.4V2.642a.4.4 0 0 0-.4-.4h-3.747z" />
      <path
        d="M4.267 3.244h2.092c.221 0 .4.18.4.4v4.533a.4.4 0 0 1-.4.4H4.267a.4.4 0 0 1-.4-.4V3.644c0-.22.179-.4.4-.4zM11.067 3.244h2.092c.221 0 .4.18.4.4v4.533a.4.4 0 0 1-.4.4h-2.092a.4.4 0 0 1-.4-.4V3.644c0-.22.179-.4.4-.4zM17.867 3.244h2.092c.221 0 .4.18.4.4v4.533a.4.4 0 0 1-.4.4h-2.092a.4.4 0 0 1-.4-.4V3.644c0-.22.179-.4.4-.4z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgMemory
